import "core-js/modules/es.array.concat.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "chat-message"
};
import IframeContainer from '@/components/IframeContainer';
import { computed } from 'vue';
import { getHostName } from '@/util/env';
import { getBaseAppsUrl } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'Message',
  props: {
    isConcat: {
      type: Boolean,
      default: false
    },
    cancatInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      token = _storeToRefs.token;
    var pathData = computed(function () {
      var hostName = getHostName();
      // console.log(hostName);
      // console.log(token.value,props.cancatInfo, 25)
      var sessionId = '';
      if (props.isConcat) {
        sessionId = '&sessionId=p2p-' + props.cancatInfo.accId;
      }
      if (hostName) {
        var url = getBaseAppsUrl('chat-qa');
        return "".concat(url, "/sessions?token=").concat(token.value, "&pageType=teacherPad").concat(sessionId);
      } else {
        return 'http://192.168.1.49:7349/sessions?token=' + token.value + '&pageType=teacherPad' + sessionId;
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(IframeContainer), {
        src: pathData.value
      }, null, 8, ["src"])]);
    };
  }
};